import styles from './FJRecording.module.less';
import FJLocalStore from '../../../../store/FJLocalStore.js';
import classNames from 'classnames';
import { useRef, useEffect } from 'react';
import FJRotateIcon from '../../../../assets/svg/rotate-left.svg?react';
import PropTypes from 'prop-types';
import FJUtil from '../../../../util/FJUtil.js';
import FJEvent from '../../../../store/FJEvent.js';
import { FJ_EVENT_TYPE } from '../../../../constants/FJEvenTypeConstant.js';
import FJToolTip from '../../../../common/components/FJToolTip/FJToolTip.jsx';
import FJConstant from '../../../../constants/FJConstant.js';
const FJRecording = props => {
    const { recorderDuration, onRetry, onStop, active, startRecord } = props;
    const waveRef = useRef(null);
    const recordVoiceType = FJUtil.getRecordVoiceType();
    useEffect(() => {
        return FJEvent.subscribe(FJ_EVENT_TYPE.START_RECORDER, () => {
            waveRef.current.innerHTML = '';
            startRecord(waveRef.current);
        });
    }, []);

    const isStopDisabled = recorderDuration < FJUtil.getRecordMinDuration();

    const _onStop = () => {
        if (isStopDisabled) {
            return;
        }
        onStop();
    };

    const recordDesc = () => {
        switch (recordVoiceType) {
            case FJConstant.RECORD_IN_CREATE_CLONE:
                return FJLocalStore._('you-can-stop-after-and-can-be-recorded-up-to');
            default:
                return FJLocalStore._('you-can-stop-after-15s-and-can-be-recorded-up-to-3min');
        }
    };

    const recordTopTip = () => {
        if (isStopDisabled) {
            switch (recordVoiceType) {
                case FJConstant.RECORD_IN_CREATE_CLONE:
                    return 'you-need-to-record-at-least-30s';
                default:
                    return 'you-need-to-record-at-least-15s';
            }
        } else {
            return 'stop-recording';
        }
    };

    return (
        <div className={styles.box} style={{ display: active ? 'block' : 'none' }}>
            <div
                className={styles.record_desc}
                dangerouslySetInnerHTML={{
                    __html: recordDesc(),
                }}
            />
            <div className={classNames(styles.wave)} ref={waveRef} />
            <div className={styles.duration}>{FJUtil.formatTime(recorderDuration, undefined, 2)}</div>
            <div className={styles.btn_group}>
                <FJToolTip title='re-record'>
                    <div className={styles.retry_btn} onClick={onRetry}>
                        <FJRotateIcon />
                    </div>
                </FJToolTip>
                <FJToolTip title={recordTopTip()}>
                    <div
                        className={classNames(styles.stop_btn, isStopDisabled ? styles.disabled : '')}
                        onClick={_onStop}
                    />
                </FJToolTip>
            </div>
        </div>
    );
};

FJRecording.propTypes = {
    recorderDuration: PropTypes.number,
    onRetry: PropTypes.func,
    onStop: PropTypes.func,
    active: PropTypes.bool,
    startRecord: PropTypes.func,
};

export default FJRecording;
